import { useCallback } from 'react';
import qs from 'query-string';
import {
  ClientResponse,
  ClientResponseData,
  SubEntityResponse,
  useAuthFetch,
} from '@cko/dashboard-shared';

type MakeRequestProps = {
  version?: string;
  query?: string;
  limit?: number;
  skip?: number;
  clientId?: string;
};

export const useMakeRequest = (basePath: string) => {
  const fetch = useAuthFetch();
  const makeRequest = useCallback(
    async (
      makeRequestProps: MakeRequestProps,
    ): Promise<ClientResponse | SubEntityResponse | ClientResponseData> => {
      const { clientId, query, limit, skip, version } = makeRequestProps;
      let url;
      if (clientId) {
        url = `${basePath}/umt/clients/${clientId}/entities`;
      } else {
        url = `${basePath}/umt/clients/selector`;
        const params = qs.stringify(
          {
            q: query,
            limit: limit || 1,
            skip,
          },
          { skipEmptyString: true },
        );
        url = `${url}?${params}`;
      }

      const headers: HeadersInit = {};

      if (version) {
        headers.Accept = `application/json;version=${version}`;
      }

      const response = await fetch(url, {
        headers,
        method: 'GET',
      });

      const data: ClientResponse | SubEntityResponse | ClientResponseData = await response.json();

      return data;
    },
    [basePath, fetch],
  );

  return makeRequest;
};
